var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import { clearState } from '../../context/reducers/userReducer';
import { clearTokenLogout } from '../../utils/commonUtil';
const LogoutButton = () => {
    const dispatch = useDispatch();
    const handleLogout = () => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(clearState());
        yield clearTokenLogout();
    });
    return _jsx(Button, { onClick: handleLogout, children: "Logout" });
};
export default LogoutButton;
